import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import moment from "moment";
import useGetHook from "../../customHooks/useGetHook";

const InvoiceList = () => {
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Invoice No.",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>INV-{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{moment(row?.original?.created).format('YY-MM-DD HH:mm:ss')}</p>
          </>
        )
      },
    },
    {
      header: "Merchant",
      accessorKey: "merchant.name",
      cell: NACell,
    },
    {
      header: "Collected COD",
      accessorKey: "collected_cod",
      cell: NACell,
    },
    {
      header: "D. Charge",
      accessorKey: "delivery_charge",
      cell: NACell,
    },
    {
      header: "Tax",
      accessorKey: "tax",
      cell: NACell,
    },
    {
      header: "Invoice Amount",
      accessorKey: "invoice_amount",
      cell: NACell,
    },
    {
      header: "Paid Date",
      accessorKey: "paid_date",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ? moment(getValue()).format('YY-MM-DD HH:mm:ss') : "N/A"}</p>
          </>
        )
      },
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className="uppercase">{getValue()}</p>
          </>
        )
      },
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`preview/${getValue()}`} />
        </>
      ),
    },
  ];
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  return (
    <DataTable
      url={APIS.INVOICE}
      queryKey={"invoice"}
      columns={defaultColumns}
      params={{}}
      addNewPagePath={userProfileType?.is_merchant ? "" : "/create-invoice"}
      tableName={"Invoices"}
    />
  );
};


export default InvoiceList
